import { createPortal } from 'react-dom'

import { useEscape } from '../../hooks/useEscape'
import { useTexte } from '../../texte'

/**
 * Before or after the target, asked once (#130, 1.117.0).
 *
 * Built like `Rueckfrage` -- on `document.body`, Escape and a tap on the
 * background say no, the safe way has the focus -- with two answers instead
 * of one: the choice and the confirmation are the same tap. The sheet names
 * the target by its day and first words, so that a tap on the wrong bubble
 * is seen before anything moves.
 */
export function Verschiebefrage({
  anzahl,
  ziel,
  onWahl,
  onAbbruch,
}: {
  anzahl: number
  /** The target as a line: day and first words. */
  ziel: string
  onWahl: (place: 'before' | 'after') => void
  onAbbruch: () => void
}) {
  const t = useTexte()
  useEscape(onAbbruch)
  return createPortal(
    <div className="rueckfrage" role="alertdialog" aria-modal="true" aria-label={t.chat.verschieben.frage(anzahl)} onClick={onAbbruch}>
      <div className="rueckfrage__blatt" onClick={(event) => event.stopPropagation()} data-verschiebefrage="">
        <p className="rueckfrage__frage">{t.chat.verschieben.frage(anzahl)}</p>
        <p className="rueckfrage__detail">{ziel}</p>
        <div className="rueckfrage__knoepfe">
          <button type="button" className="button button--outline button--small" onClick={onAbbruch} autoFocus>
            {t.allgemein.abbrechen}
          </button>
          <button type="button" className="button button--small" onClick={() => onWahl('before')} data-verschieben-wohin="before">
            {t.chat.verschieben.davor}
          </button>
          <button type="button" className="button button--small" onClick={() => onWahl('after')} data-verschieben-wohin="after">
            {t.chat.verschieben.danach}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
